export default {
	state: {
		pmPlans: [],
		pmPlanBudgets: [],
		pmPlanProviders: []
	},

	actions: {
		getPmPlans(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile

					var columns = "" +
						"pmp.id, " +
						"pmp.name";

					var tableName = "" +
						"@db.pmplan pmp " +
						"inner join @db.client c on pmp.clientid = c.id " +
						"inner join @db.clientcareworkers ccw on c.id = ccw.clientid";

					var filter = "" +
						"(ccw.userid = " + profile.userid + " " +
							"or c.lastname like '%admin%') " +
						"and pmp.inactive = 0";

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?columns=${columns}&tableName=${tableName}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setPmPlans", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getPmPlanBudgets(actionContext, pmPlanId) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var columns = "" +
						"pmpb.categoryid";

					var tableName = "" +
						"@db.pmplanbudget pmpb";

					var filter = "" +
						"pmpb.pmplanid = " + pmPlanId + " " +
						"and pmpb.inactive = 0";

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?columns=${columns}&tableName=${tableName}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setPmPlanBudgets", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getPmPlanProviders(actionContext, pmPlanId) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var columns = "" +
						"pmpp.id, " +
						"pmpp.name, " +
						"pmpp.pmplanid, " +
						"a.name as serviceprovidername, " +
						"pmpp.budget, " +
						"pmpp.utilised, " +
						"pmpp.balance, " +
						"pmpp.startdate, " +
						"pmpp.enddate";

					var tableName = "" +
						"@db.pmplanprovider pmpp " +
						"inner join @db.account a on pmpp.serviceproviderid = a.id";

					var filter = "" +
						"pmpp.pmplanid = " + pmPlanId + " " +
						"and pmpp.inactive = 0";

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?columns=${columns}&tableName=${tableName}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setPmPlanProviders", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getMaxBudget(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var columns = "" +
						"sum(pmb.balance) - sum(ifnull(pmp.budget,0)) as balance";

					var tableName = "" +
						"@db.pmplanbudget pmb " +
						"left join @db.pmplanprovider pmp on pmb.categoryid = pmp.categoryid";

					var filter = "" +
						`pmb.pmplanid=${parameters.pmPlanId} ` +
						"and pmb.inactive = 0 " +
						`and pmb.categoryid = ${parameters.categoryId} ` +
						`and (pmp.id is null or pmp.id != ${parameters.id}) ` +
						"group by " +
						"pmb.categoryid, pmp.categoryid";

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?columns=${columns}&tableName=${tableName}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("Loading/hide", null, { root: true })

							var budget = 0

							if (records.length === 1)
								budget = parseFloat(records[0].balance)

							resolve(budget)
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		savetPmPlanProvider(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile
					var itemsToSave = [
						{
							name: "name",
							value: parameters.name
						},
						{
							name: "serviceproviderid",
							value: parameters.serviceProviderId
						},
						{
							name: "categoryid",
							value: parameters.categoryId
						},
						{
							name: "pmplanid",
							value: parameters.pmPlanId
						},
						{
							name: "budget",
							value: parameters.budget
						},
						{
							name: "startdate",
							value: parameters.startDate
						},
						{
							name: "enddate",
							value: parameters.endDate
						}
					]

					var saveObj = {
						userId: profile.userid,
						TableName: "pmplanprovider",
						RecordId: parameters.id,
						Data: JSON.stringify(itemsToSave)
					}

					actionContext.rootGetters["MopaneApi/getInstance"].post(`Service/SaveDynamicFormData`, saveObj)
						.then(response => {
							actionContext.commit("Loading/hide", null, { root: true })

							resolve(response.data)
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setPmPlans(state, pmPlans) {
			state.pmPlans = pmPlans
		},
		setPmPlanBudgets(state, pmPlanBudgets) {
			state.pmPlanBudgets = pmPlanBudgets
		},
		setPmPlanProviders(state, pmPlanProviders) {
			state.pmPlanProviders = pmPlanProviders
		}
	},

	namespaced: true
}